import { Pressable, Text, View } from 'react-native'
import { useRouter } from 'expo-router'
import { setPendingCrashReport } from '@/src/utils/pending-crash-report'
import { useTranslation } from 'react-i18next'

export type SentryErrorFallbackProps = {
  error: unknown
  componentStack: string
  eventId: string
  resetError(): void
  showReportIssueAction?: boolean
}

export function SentryErrorFallback({
  error,
  componentStack,
  eventId,
  resetError,
  showReportIssueAction = false,
}: SentryErrorFallbackProps) {
  const { t } = useTranslation(['common'])
  const { push } = useRouter()

  const handleReportIssue = () => {
    setPendingCrashReport({
      message:
        error instanceof Error
          ? error.message
          : error != null
            ? String(error)
            : undefined,
      componentStack,
    })
    if (eventId) {
      push({ pathname: '/report-issue', params: { eventId } })
    } else {
      push('/report-issue')
    }
    resetError()
  }

  return (
    <View className="flex-1 justify-center items-center bg-background-primary px-6">
      <Text className="text-xl font-bold text-black mb-3 text-center">
        {t('common:sentry_error_title')}
      </Text>
      <Text className="text-base text-gray-500 mb-4 text-center">
        {t('common:sentry_error_message')}
      </Text>
      {__DEV__ && error != null && (
        <Text className="text-sm text-red-500 mb-4 text-center">
          {error instanceof Error ? error.message : String(error)}
        </Text>
      )}
      <Pressable
        className="bg-primary px-6 py-3 rounded-lg mb-3"
        onPress={resetError}
      >
        <Text className="text-white font-semibold text-base">
          {t('common:error_try_again')}
        </Text>
      </Pressable>
      {showReportIssueAction ? (
        <Pressable
          className="border border-border px-6 py-3 rounded-lg mb-4"
          onPress={handleReportIssue}
        >
          <Text className="text-ink font-semibold text-base">
            {t('common:sentry_error_report_issue')}
          </Text>
        </Pressable>
      ) : null}
      {eventId ? (
        <Text className="text-xs text-gray-400 text-center">
          Reference: {eventId}
        </Text>
      ) : null}
    </View>
  )
}
